import {BASE_ENV} from './base';

export const environment = {
  ...BASE_ENV,
  production  : true,
  apiBaseUrl: '/api'
};
